import { ErrorBoundary } from '@datadog/browser-rum-react'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import ErrorFallbackUI from 'components/ErrorFallbackUI/ErrorFallbackUI'
import { Header, HeaderProvider, Layout } from 'features/commonUI'
import { subscriptionsQueryOptions } from 'hooks/api/subscriptions'

export const Route = createFileRoute('/_authenticated/_layout')({
  component: () => (
    <Layout>
      <HeaderProvider>
        <Header />
        <ErrorBoundary fallback={ErrorFallbackUI}>
          <Outlet />
        </ErrorBoundary>
      </HeaderProvider>
    </Layout>
  ),
  loader: ({ context: { queryClient, buildRequest } }) => {
    queryClient.prefetchQuery(subscriptionsQueryOptions(buildRequest, []))
  },
})
